import { render, staticRenderFns } from "./novel_create_label5.vue?vue&type=template&id=5cdcf404&scoped=true"
import script from "./novel_create_label5.vue?vue&type=script&lang=js"
export * from "./novel_create_label5.vue?vue&type=script&lang=js"
import style0 from "./novel_create_label5.vue?vue&type=style&index=0&id=5cdcf404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdcf404",
  null
  
)

export default component.exports